import { useApi } from './useApi';
import { createOilFinderApi, useOilFinderApi } from '../services/oilFinderApi';
export function useOilFinder() {
    const { apiBaseUrl } = useApi();
    // Initialise the API service if not already done
    const api = apiBaseUrl ? createOilFinderApi(apiBaseUrl) : useOilFinderApi();
    return {
        api,
        apiBaseUrl
    };
}
